/**
 * Footer — site footer matching the existing therunninggenie.com style.
 */
export class Footer {
  /** Render the footer into the given container element. */
  render(container) {
    const footer = document.createElement('footer');
    footer.className = 'site-footer';
    const year = new Date().getFullYear();
    footer.innerHTML = `
      <p>&copy; ${year} The Running Genie. <a href="/privacy.html">Privacy</a> &middot; <a href="/terms.html">Terms</a> &middot; <a href="/support.html">Support</a></p>
    `;
    container.appendChild(footer);
  }
}
